import { css } from "styled-components";

export const BankIntegrationModalCss = css`
    .bank-connect-modal {
        .ant-modal-confirm-title {
            flex: 0 0 auto !important;
            margin-left: 1ch;
        }
    }
`;
